import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-contenido" }
const _hoisted_3 = {
  key: 0,
  class: "wrap"
}
const _hoisted_4 = { class: "top" }
const _hoisted_5 = {
  key: 0,
  class: "estado-bar"
}
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "fila-selector" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "sub-card"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "botones" }
const _hoisted_13 = {
  key: 1,
  class: "card"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-row" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  key: 2,
  class: "card"
}
const _hoisted_20 = { class: "fila-selector" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "botones"
}
const _hoisted_23 = {
  key: 1,
  class: "sub-card"
}
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "botones" }
const _hoisted_28 = {
  key: 2,
  class: "grupos-vinculados"
}
const _hoisted_29 = { class: "grupo-selector" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "hint-seleccionar-grupo"
}
const _hoisted_32 = { class: "hint-seleccionar-flecha" }
const _hoisted_33 = {
  key: 1,
  class: "preguntas-panel"
}
const _hoisted_34 = { class: "preguntas-head" }
const _hoisted_35 = {
  key: 0,
  class: "pill"
}
const _hoisted_36 = { class: "qh" }
const _hoisted_37 = { class: "qn" }
const _hoisted_38 = { class: "qt" }
const _hoisted_39 = {
  key: 0,
  class: "tag"
}
const _hoisted_40 = {
  key: 0,
  class: "opciones"
}
const _hoisted_41 = {
  key: 1,
  class: "resp-show"
}
const _hoisted_42 = {
  key: 2,
  class: "rating"
}
const _hoisted_43 = {
  key: 3,
  class: "tabla-opinion"
}
const _hoisted_44 = { class: "tabla-evaluacion" }
const _hoisted_45 = { class: "botones" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 4,
  class: "copia-panel"
}
const _hoisted_49 = { class: "grupos-check-list" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "botones" }
const _hoisted_52 = ["disabled"]
const _hoisted_53 = { class: "botones" }
const _hoisted_54 = {
  key: 3,
  class: "sub-card"
}
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = {
  key: 0,
  class: "form-group"
}
const _hoisted_58 = {
  key: 1,
  class: "escala-config"
}
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "form-group" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "botones" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = { class: "botones botones-finales" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = ["disabled"]

import { ref, onMounted, computed } from 'vue'
import { useGestionInstrumento } from '@/store/GestionInstrumentos'
import { useGestionGrupoInteres } from '@/store/GestionGrupoInteres'
import { useGestionPreguntas } from '@/store/GestionPreguntas'
import type GrupoInteres from '@/interfaces/GrupoInteres'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useGestionTipoComponente } from '@/store/GestionTipoComponente'
import { useGestionConfiguracionInstrumento } from '@/store/GestionConfiguracionInstrumento'
import { useGestionBancoPreguntas } from '@/store/GestionBancoPreguntas'
import { primerError } from '@/services/http'
import type TipoComponente from '@/interfaces/TipoComponente'
import type Instrumento from '@/interfaces/Instrumetos'
import { watch } from 'vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import useAutenticar from '@/store/IngresoAutenticar'
import BancoPreguntasSugerenciasModal from '@/components/BancoPreguntasSugerenciasModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstrumentosView',
  props: {
    visible: { type: Boolean },
    idTipoComponente: {},
    idIndicador: {},
    idInstrumento: {}
  },
  emits: ["cerrar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Construcción y ciclo de vida de los instrumentos.
 *
 * Máquina de estados edicion → aprobado → asignado → completado. Al completarse
 * el instrumento pasa al repositorio reutilizable y ya no vuelve a edición.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const instrumentoStore = useGestionInstrumento()
const grupoStore = useGestionGrupoInteres()
const preguntaStore = useGestionPreguntas()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const tipoComponenteStore = useGestionTipoComponente()
const configStore = useGestionConfiguracionInstrumento()
const bancoStore = useGestionBancoPreguntas()
const tipoComponenteActual = ref<TipoComponente | null>(null)
const variantesOpinion = ref<string[]>([])
const props = __props
const emit = __emit
const authStore = useAutenticar()
const loading = ref(false)
const loadingAccion = ref(false)
const loadingMensaje = ref('Guardando instrumento...')
const modoEdicion = ref(false)
const instrumentoSeleccionado = ref<any>(null)
const mostrarFormInstrumento = ref(false)
const nombreInstrumento = ref('')
const descripcionInstrumento = ref('')
const grupoSeleccionado = ref<any>(null)
const mostrarGrupoForm = ref(false)
const grupoActivo = ref<any>(null)
const nombreGrupo = ref('')
const tipoMuestreo = ref('')
const criterio = ref('')
const mostrarFormPregunta = ref(false)
const preguntaCopiar = ref<any>(null)
const gruposCopiaDestino = ref<(number | string)[]>([])
const copiando = ref(false)
const mostrarBancoModal = ref(false)
const tipoPregunta = ref('')
const enunciadoPregunta = ref('')
const opcionesPregunta = ref<string[]>([])
const opcionesTextoPregunta = ref('')
const escalaMinPregunta = ref(1)
const escalaMaxPregunta = ref(5)
const etiquetaMinPregunta = ref('')
const etiquetaMaxPregunta = ref('')
const TIPOS_SELECCION_PREGUNTA = ['single_choice', 'multiple_choice', 'desplegable']
const esTipoSeleccionPregunta = computed(() => TIPOS_SELECCION_PREGUNTA.includes(tipoPregunta.value))
function opcionesPreguntaDesdeTexto(): string[] {
  return opcionesTextoPregunta.value.split('\n').map(o => o.trim()).filter(Boolean)
}
const puedeGuardarPreguntaLocal = computed(() => {
  if (!enunciadoPregunta.value.trim() || !tipoPregunta.value) return false
  if (esTipoSeleccionPregunta.value) return opcionesPreguntaDesdeTexto().length >= 2
  return true
})
function construirOpcionesPregunta(): string[] | Record<string, unknown> {
  if (tipoPregunta.value === 'opinion') return []
  if (esTipoSeleccionPregunta.value) return opcionesPreguntaDesdeTexto()
  if (tipoPregunta.value === 'escala_lineal') {
    return {
      min: escalaMinPregunta.value,
      max: escalaMaxPregunta.value,
      etiqueta_min: etiquetaMinPregunta.value.trim() || undefined,
      etiqueta_max: etiquetaMaxPregunta.value.trim() || undefined,
    }
  }
  return []
}
const editandoInstrumento = ref<Instrumento | null>(null)
const tipoInstrumentoId = ref<number | ''>('')
const gruposInteres = ref<any[] | null>(null)
const criteriosOpinion = ref<string[]>([])
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')
const feedback = ref('')
const vigenciaDesde = ref('')
const vigenciaHasta = ref('')
const nombreFormulario = ref('')
const instruccionesFormulario = ref('')

const instrumentosPorTipo = ref<Record<string, string[]>>({
  'documental': ['Ficha de revisión Documental'],
  'cuantitativa': ['Ficha de revisión de indicadores Estadísticos'],
  'opinión': ['Encuesta', 'Entrevista', 'Grupos Focales', 'Observación', 'Mesa-Taller']
})

function etiquetaTipo(tipo: string): string {
  const map: Record<string, string> = {
    single_choice: 'Opción única',
    opcion_unica: 'Opción única',
    opcion_multiple: 'Opción única',
    multiple_choice: 'Casillas',
    casillas: 'Casillas',
    checkbox: 'Casillas',
    desplegable: 'Lista desplegable',
    dropdown: 'Lista desplegable',
    opinion: 'Opinión',
    long_text: 'Párrafo',
    parrafo: 'Párrafo',
    texto: 'Párrafo',
    respuesta_corta: 'Respuesta corta',
    numerica: 'Respuesta corta',
    escala_likert: 'Escala Likert',
    escala_lineal: 'Escala lineal',
    linear_scale: 'Escala lineal',
    rating: 'Escala lineal',
    fecha: 'Fecha',
    hora: 'Hora'
  }
  return map[tipo] || tipo
}

watch(nombreInstrumento, (nuevo) => {
  if (!nuevo) {
    instrumentoSeleccionado.value = null
    return
  }
  instrumentoSeleccionado.value = {
    herramienta: nuevo,
    descripcion: '',
    id_tipo_componente: props.idTipoComponente,
    grupos_interes: []
  }
})

const opcionesInstrumentos = computed(() => {
  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  const clave = Object.keys(instrumentosPorTipo.value).find(k => nombre.includes(k))
  return clave ? instrumentosPorTipo.value[clave] : []
})

function requiereGruposYPreguntas(): boolean {
  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  return nombre.includes('opinión') || nombre.includes('opinion')
}

const gruposVinculados = computed(() => {
  if (!instrumentoSeleccionado.value?.gruposInteres) return []
  return instrumentoSeleccionado.value.gruposInteres
})

const otrosGrupos = computed(() => {
  const todos = instrumentoSeleccionado.value?.grupos_interes ?? []
  const claveActivo = grupoActivo.value?.id_temp ?? grupoActivo.value?.id_grupo_interes
  return todos.filter((g: any) => (g.id_temp ?? g.id_grupo_interes) !== claveActivo)
})

function onModificarInstrumento(instrumento: Instrumento) {
  editandoInstrumento.value = instrumento
  nombreInstrumento.value = instrumento.herramienta
  descripcionInstrumento.value = instrumento.descripcion
  tipoInstrumentoId.value = instrumento.id_tipo_componente
  gruposInteres.value = instrumento.grupos_interes ?? null
  mostrarFormInstrumento.value = true
}

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

async function cargarDatosInstrumento() {
  mensajeVisible.value = false
  modoEdicion.value = false
  editandoInstrumento.value = null
  nombreInstrumento.value = ''
  descripcionInstrumento.value = ''
  vigenciaDesde.value = ''
  vigenciaHasta.value = ''
  nombreFormulario.value = ''
  instruccionesFormulario.value = ''
  instrumentoSeleccionado.value = null
  grupoSeleccionado.value = null
  grupoActivo.value = null
  mostrarFormInstrumento.value = false
  mostrarGrupoForm.value = false
  mostrarFormPregunta.value = false

  loading.value = true

  try {
    const cargarGrupos = grupoStore.getGrupos()
    const cargarTipo = props.idTipoComponente
      ? tipoComponenteStore.getTipoById(props.idTipoComponente)
      : Promise.resolve(null)

    const [, tipo] = await Promise.all([cargarGrupos, cargarTipo])
    tipoComponenteActual.value = tipo

    if (props.idInstrumento) {
      const instrumento = await instrumentoStore.getInstrumentoById(props.idInstrumento)
      if (instrumento) {
        modoEdicion.value = true
        editandoInstrumento.value = instrumento
        nombreInstrumento.value = instrumento.herramienta
        descripcionInstrumento.value = instrumento.descripcion ?? ''

        const preguntasPorGrupo = await instrumentoStore.getPreguntasPorGrupo(props.idInstrumento)
        const gruposCargados = (preguntasPorGrupo as any)?.grupos ?? []

        instrumentoSeleccionado.value = {
          id_instrumento: instrumento.id_instrumento,
          herramienta: instrumento.herramienta,
          descripcion: instrumento.descripcion,
          id_tipo_componente: instrumento.id_tipo_componente,
          grupos_interes: gruposCargados.map((g: any) => ({
            id_grupo_interes: g.grupo?.id_grupo_interes ?? null,
            nombre: g.nombre_grupo,
            preguntas: (g.preguntas ?? []).map((p: any) => ({
              id_pregunta: p.id_pregunta,
              enunciado: p.pregunta ?? p.enunciado,
              tipo_respuesta: p.tipo ?? p.tipo_respuesta,
              opciones: p.opciones ?? [],
              variantes: p.variantes ?? [],
              criterios: p.criterios ?? []
            }))
          })).filter((g: any) => g.id_grupo_interes !== null)
        }

        if (requiereGruposYPreguntas()) {
          await configStore.listar({ id_instrumento: props.idInstrumento! })
          const configActiva = configStore.configuraciones.find(
            c => c.estado === 'publicada' || c.estado === 'borrador'
          ) ?? configStore.configuraciones[0] ?? null
          if (configActiva) {
            vigenciaDesde.value = configActiva.vigencia_desde.slice(0, 10)
            vigenciaHasta.value = configActiva.vigencia_hasta.slice(0, 10)
            nombreFormulario.value = configActiva.titulo ?? ''
            instruccionesFormulario.value = configActiva.instrucciones ?? ''
          }
        }
      }
    }
  } catch (e: any) {
    console.error('Error al cargar datos del instrumento:', e)
    mostrarMensaje('Error al cargar datos del instrumento', 'error')
  } finally {
    loading.value = false
  }
}

watch(
  () => [props.visible, props.idTipoComponente, props.idIndicador, props.idInstrumento] as const,
  ([nuevoVisible, nuevoTipo, nuevoIndicador, nuevoInstrumento], [viejoVisible, viejoTipo, viejoIndicador, viejoInstrumento]) => {
    const seAbrio = nuevoVisible && !viejoVisible
    const cambioPropId = nuevoVisible && (
      nuevoTipo !== viejoTipo ||
      nuevoIndicador !== viejoIndicador ||
      nuevoInstrumento !== viejoInstrumento
    )
    if (seAbrio || cambioPropId) {
      cargarDatosInstrumento()
    }
  }
)

onMounted(async () => {
  if (props.visible) {
    await cargarDatosInstrumento()
  }
})

function vincularGrupoSeleccionado() {
  if (!instrumentoSeleccionado.value) return
  if (!grupoSeleccionado.value) return

  const yaVinculado = instrumentoSeleccionado.value.grupos_interes?.some(
    (g: GrupoInteres) => g.id_grupo_interes === grupoSeleccionado.value.id_grupo_interes
  )
  if (yaVinculado) {
    console.warn('Este grupo ya está vinculado al instrumento')
    grupoSeleccionado.value = null
    return
  }

  if (!instrumentoSeleccionado.value.grupos_interes) {
    instrumentoSeleccionado.value.grupos_interes = []
  }

  const grupoConPreguntas = {
    ...grupoSeleccionado.value,
    preguntas: grupoSeleccionado.value.preguntas ?? []
  }

  instrumentoSeleccionado.value.grupos_interes.push(grupoConPreguntas)
  grupoSeleccionado.value = null
  grupoActivo.value = grupoConPreguntas
}

function nuevoInstrumentoLocal() {
  const nuevoNombre = nombreInstrumento.value

  instrumentoSeleccionado.value = {
    herramienta: nuevoNombre,
    descripcion: descripcionInstrumento.value,
    id_tipo_componente: props.idTipoComponente,
    grupos_interes: []
  }

  const nombre = (tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo)?.toLowerCase() ?? ''
  const clave = Object.keys(instrumentosPorTipo.value).find(k => nombre.includes(k))
  if (clave && !instrumentosPorTipo.value[clave].includes(nuevoNombre)) {
    instrumentosPorTipo.value[clave].push(nuevoNombre)
  }

  mostrarFormInstrumento.value = false
}

function agregarGrupoLocal() {
  if (!requiereGruposYPreguntas()) return

  const nuevo = {
    id_temp: Date.now(),
    nombre: nombreGrupo.value,
    tipo_muestreo: tipoMuestreo.value,
    criterios: criterio.value,
    preguntas: []
  }
  instrumentoSeleccionado.value?.grupos_interes.push(nuevo)
  grupoActivo.value = nuevo
  nombreGrupo.value = ''
  tipoMuestreo.value = ''
  criterio.value = ''
  mostrarGrupoForm.value = false
}

function agregarDesdeBanco(preguntas: any[]) {
  if (!grupoActivo.value) return
  const base = Date.now()
  preguntas.forEach((p, i) => {
    grupoActivo.value.preguntas.push({
      id_temp: base + i,
      id_pregunta_banco: p.id_pregunta ?? null,
      enunciado: p.enunciado || p.pregunta || '',
      tipo_respuesta: p.tipo_respuesta || p.tipo || '',
      opciones: p.opciones ?? [],
      variantes: [],
      criterios: [],
    })
  })
}

async function sincronizarPreguntasConBanco(idIndicador: number): Promise<boolean> {
  if (!authStore.esAdmin && !authStore.tienePermiso('banco.gestionar')) {
    mostrarMensaje(
      'El instrumento fue guardado, pero no se generó el formulario porque tu usuario no tiene permiso para gestionar el banco de preguntas.',
      'error'
    )
    return false
  }

  const grupos = instrumentoSeleccionado.value?.grupos_interes ?? []
  if (grupos.length === 0) return true

  // Fase 1: cargar banco actual para detectar duplicados
  loadingMensaje.value = 'Cargando banco de preguntas...'
  await bancoStore.cargarBanco()

  // Recopilar todas las preguntas de todos los grupos
  const pendientes: Array<{ enunciado: string; tipo: string; id_grupo_interes: number | null; opciones: string[]; id_pregunta_banco: number | null }> = []
  for (const g of grupos) {
    for (const p of g.preguntas ?? []) {
      pendientes.push({
        enunciado: p.enunciado ?? '',
        tipo: p.tipo_respuesta ?? '',
        id_grupo_interes: g.id_grupo_interes ?? null,
        opciones: p.opciones ?? [],
        id_pregunta_banco: p.id_pregunta_banco ?? null,
      })
    }
  }
  if (pendientes.length === 0) return true

  // Fase 2: crear en el banco las preguntas que no existan, acumular IDs
  loadingMensaje.value = 'Registrando preguntas en el banco...'
  // Separar las que ya tienen ID (lookup síncrono) de las que hay que crear
  const idsPorIndice: (number | undefined)[] = new Array(pendientes.length)
  const aCrear: Array<{ idx: number; pq: typeof pendientes[0] }> = []

  for (let i = 0; i < pendientes.length; i++) {
    const pq = pendientes[i]
    if (pq.id_pregunta_banco) {
      idsPorIndice[i] = pq.id_pregunta_banco
      continue
    }
    const enunciado = pq.enunciado.trim().toLowerCase()
    const existente = bancoStore.preguntasBanco.find(
      b => (b.enunciado ?? b.pregunta ?? '').trim().toLowerCase() === enunciado
    )
    if (existente?.id_pregunta) {
      idsPorIndice[i] = existente.id_pregunta
      continue
    }
    aCrear.push({ idx: i, pq })
  }

  // Crear en banco en paralelo
  const resultadosCrear = await Promise.allSettled(
    aCrear.map(({ pq }) => bancoStore.crearPregunta({
      pregunta: pq.enunciado,
      tipo: pq.tipo,
      id_grupo_interes: pq.id_grupo_interes,
      opciones: pq.opciones,
    }))
  )
  for (let i = 0; i < resultadosCrear.length; i++) {
    const r = resultadosCrear[i]
    const { idx } = aCrear[i]
    if (r.status === 'rejected' || !r.value.ok) {
      mostrarMensaje('No se pudo registrar la pregunta en el banco.', 'error')
      return false
    }
    if (!r.value.data?.id_pregunta) {
      mostrarMensaje('El banco no devolvió el ID de la pregunta creada.', 'error')
      return false
    }
    idsPorIndice[idx] = r.value.data.id_pregunta
  }
  const idsPreguntasBanco = idsPorIndice.filter((id): id is number => id != null)

  // Fase 3: vincular al indicador en paralelo
  loadingMensaje.value = 'Vinculando preguntas al indicador...'
  const resultadosAsign = await Promise.allSettled(
    idsPreguntasBanco.map(idPregunta => bancoStore.asignarAIndicadores(idPregunta, [idIndicador]))
  )
  for (const r of resultadosAsign) {
    if (r.status === 'rejected' || !r.value.ok) {
      const val = r.status === 'fulfilled' ? r.value : { ok: false, status: 0, errors: {} }
      const msg = (val as any).status === 403
        ? 'Sin permiso para vincular preguntas al indicador. Contacta a un coordinador o administrador.'
        : primerError(val as any)
      mostrarMensaje(`No se pudo vincular la pregunta al indicador: ${msg}`, 'error')
      return false
    }
  }

  return true
}

function agregarPreguntaLocal(grupo: any) {
  if (!requiereGruposYPreguntas() || !grupo) return
  grupo.preguntas.push({
    id_temp: Date.now(),
    enunciado: enunciadoPregunta.value,
    tipo_respuesta: tipoPregunta.value,
    variantes: tipoPregunta.value === 'opinion' ? [...variantesOpinion.value] : [],
    criterios: tipoPregunta.value === 'opinion' ? [...criteriosOpinion.value] : [],
    opciones: construirOpcionesPregunta()
  })
  cancelarPregunta()
}

function abrirCopia(pregunta: any) {
  if (preguntaCopiar.value === pregunta) {
    cancelarCopia()
    return
  }
  preguntaCopiar.value = pregunta
  gruposCopiaDestino.value = []
}

function cancelarCopia() {
  preguntaCopiar.value = null
  gruposCopiaDestino.value = []
}

async function copiarPreguntaAGrupos() {
  if (!preguntaCopiar.value || gruposCopiaDestino.value.length === 0) return
  copiando.value = true
  await new Promise(r => setTimeout(r, 0))

  const base = Date.now()
  const todosGrupos = instrumentoSeleccionado.value?.grupos_interes ?? []
  const yaExiste: string[] = []
  const copiados: string[] = []

  todosGrupos.forEach((g: any, i: number) => {
    const key = g.id_temp ?? g.id_grupo_interes
    if (!gruposCopiaDestino.value.includes(key)) return
    const duplicado = (g.preguntas ?? []).some(
      (p: any) => p.enunciado?.trim().toLowerCase() === preguntaCopiar.value.enunciado?.trim().toLowerCase()
    )
    if (duplicado) {
      yaExiste.push(g.nombre)
      return
    }
    g.preguntas.push({
      id_temp: base + i,
      enunciado: preguntaCopiar.value.enunciado,
      tipo_respuesta: preguntaCopiar.value.tipo_respuesta,
      variantes: [...(preguntaCopiar.value.variantes ?? [])],
      criterios: [...(preguntaCopiar.value.criterios ?? [])],
      opciones: [...(preguntaCopiar.value.opciones ?? [])]
    })
    copiados.push(g.nombre)
  })

  copiando.value = false
  cancelarCopia()

  if (copiados.length > 0) {
    mostrarMensaje(`Pregunta copiada a: ${copiados.join(', ')}`, 'positivo')
  }
  if (yaExiste.length > 0) {
    mostrarMensaje(`La pregunta ya existe en: ${yaExiste.join(', ')}`, 'error')
  }
}

function quitarGrupo(grupo: any) {
  if (!instrumentoSeleccionado.value?.grupos_interes) return

  instrumentoSeleccionado.value.grupos_interes = instrumentoSeleccionado.value.grupos_interes.filter(
    (g: any) => (g.id_temp || g.id_grupo_interes) !== (grupo.id_temp || grupo.id_grupo_interes)
  )

  if (grupoActivo.value && (grupoActivo.value.id_temp || grupoActivo.value.id_grupo_interes) === (grupo.id_temp || grupo.id_grupo_interes)) {
    grupoActivo.value = null
  }
}

async function guardarInstrumento() {
  if (loadingAccion.value) return
  feedback.value = ''
  loadingMensaje.value = 'Guardando instrumento...'
  loadingAccion.value = true
  try {
    if (!nombreInstrumento.value) {
      mostrarMensaje('No hay instrumento seleccionado, se detiene la función', 'error')
      return
    }

    if (requiereGruposYPreguntas()) {
      const grupos: any[] = instrumentoSeleccionado.value?.grupos_interes ?? []
      const tieneGrupoConPregunta = grupos.some(g => (g.preguntas?.length ?? 0) > 0)
      if (grupos.length === 0 || !tieneGrupoConPregunta) {
        mostrarMensaje('Debe agregar al menos un grupo de interés con al menos una pregunta antes de guardar.', 'error')
        return
      }
    }

    if (modoEdicion.value && editandoInstrumento.value?.id_instrumento) {
      const idInst = editandoInstrumento.value.id_instrumento

      const payloadUpdate = {
        herramienta: nombreInstrumento.value,
        descripcion: descripcionInstrumento.value,
        id_tipo_componente: props.idTipoComponente
      }

      const actualizado = await instrumentoStore.actualizarInstrumento(idInst, payloadUpdate)
      if (!actualizado) {
        mostrarMensaje('No se pudo actualizar el instrumento', 'error')
        return
      }

      if (requiereGruposYPreguntas()) {
        const gruposIds: number[] = []

        const gruposInteresModif = instrumentoSeleccionado.value?.grupos_interes || []

        // Crear grupos nuevos en paralelo
        await Promise.allSettled(
          gruposInteresModif
            .filter((g: any) => !g.id_grupo_interes)
            .map(async (g: any) => {
              const grupoCreado = await grupoStore.crearGrupo({
                nombre: g.nombre,
                tipo_muestreo: g.tipo_muestreo,
                criterios: g.criterios
              })
              if (grupoCreado?.id_grupo_interes) g.id_grupo_interes = grupoCreado.id_grupo_interes
            })
        )

        // Recopilar IDs y preguntas pendientes
        const preguntasPendientesModif: Array<{ p: any; idGrupoInteres: number }> = []
        for (const g of gruposInteresModif) {
          const idGrupoInteres: number | null = g.id_grupo_interes ?? null
          if (idGrupoInteres !== null) {
            gruposIds.push(idGrupoInteres)
            for (const p of g.preguntas) {
              if (p.id_temp && !p.id_pregunta) preguntasPendientesModif.push({ p, idGrupoInteres })
            }
          }
        }

        // Crear preguntas en paralelo
        await Promise.allSettled(
          preguntasPendientesModif.map(({ p, idGrupoInteres }) => preguntaStore.crearPregunta({
            enunciado: p.enunciado,
            pregunta: p.enunciado,
            tipo_respuesta: p.tipo_respuesta,
            tipo: p.tipo_respuesta,
            opciones: p.opciones,
            id_instrumento: idInst,
            id_grupo_interes: idGrupoInteres,
            orden: p.orden ?? null
          }))
        )

        if (gruposIds.length > 0) {
          await instrumentoStore.asignarGrupos(idInst, gruposIds)
        }
      }

      if (requiereGruposYPreguntas() && vigenciaDesde.value && vigenciaHasta.value) {
        loadingMensaje.value = 'Registrando preguntas en el banco...'
        const sincrOk = await sincronizarPreguntasConBanco(props.idIndicador)
        if (!sincrOk) return
        loadingMensaje.value = 'Generando formulario de Google Forms...'
        const configResult = await configStore.crear({
          id_instrumento: idInst,
          id_indicador: props.idIndicador,
          vigencia_desde: vigenciaDesde.value,
          vigencia_hasta: vigenciaHasta.value,
          titulo: nombreFormulario.value.trim() || undefined,
          instrucciones: instruccionesFormulario.value.trim() || undefined
        })
        if (configResult.ok && configResult.data?.id_configuracion) {
          await configStore.publicar(configResult.data.id_configuracion)
        } else if (!configResult.ok) {
          mostrarMensaje(`Instrumento guardado. No se generó el formulario: ${primerError(configResult)}`, 'error')
          return
        }
      }

      sessionStorage.setItem('instrumento_creado', 'Instrumento actualizado correctamente')
      emit('cerrar')
      return
    }

    const nuevo = await instrumentoStore.crearInstrumento({
      herramienta: nombreInstrumento.value,
      descripcion: descripcionInstrumento.value,
      id_tipo_componente: props.idTipoComponente
    })
    if (!nuevo?.id_instrumento) {
      mostrarMensaje('No se creó el instrumento correctamente', 'error')
      return
    }

    const relacion = await indicadorInstrumentoStore.crearRelacion({
      id_indicador: props.idIndicador,
      id_instrumento: nuevo.id_instrumento
    })
    if (!relacion?.id) {
      mostrarMensaje('No se pudo vincular el indicador con el instrumento', 'error')
      return
    }

    if (requiereGruposYPreguntas()) {
      const gruposIds: number[] = []
      const preguntasPendientes: Array<{ p: any; idGrupoInteres: number }> = []

      const gruposInteresCr = instrumentoSeleccionado.value?.grupos_interes || []

      // Crear grupos nuevos en paralelo
      await Promise.allSettled(
        gruposInteresCr
          .filter((g: any) => !g.id_grupo_interes)
          .map(async (g: any) => {
            const grupoCreado = await grupoStore.crearGrupo({
              nombre: g.nombre,
              tipo_muestreo: g.tipo_muestreo,
              criterios: g.criterios
            })
            if (grupoCreado?.id_grupo_interes) g.id_grupo_interes = grupoCreado.id_grupo_interes
          })
      )

      // Recopilar IDs y preguntas
      for (const g of gruposInteresCr) {
        const idGrupoInteres: number | null = g.id_grupo_interes ?? null
        if (idGrupoInteres !== null) {
          gruposIds.push(idGrupoInteres)
          for (const p of g.preguntas) {
            preguntasPendientes.push({ p, idGrupoInteres })
          }
        }
      }

      if (gruposIds.length > 0) {
        await grupoStore.asignarGruposAInstrumento(nuevo.id_instrumento, gruposIds)
      }

      // Crear preguntas en paralelo
      await Promise.allSettled(
        preguntasPendientes.map(({ p, idGrupoInteres }) => preguntaStore.crearPregunta({
          enunciado: p.enunciado,
          pregunta: p.enunciado,
          tipo_respuesta: p.tipo_respuesta,
          tipo: p.tipo_respuesta,
          opciones: p.opciones,
          id_instrumento: nuevo.id_instrumento,
          id_grupo_interes: idGrupoInteres,
          orden: p.orden ?? null
        }))
      )
    }

    if (requiereGruposYPreguntas() && vigenciaDesde.value && vigenciaHasta.value) {
      loadingMensaje.value = 'Registrando preguntas en el banco...'
      const sincrOk = await sincronizarPreguntasConBanco(props.idIndicador)
      if (!sincrOk) return
      loadingMensaje.value = 'Generando formulario de Google Forms...'
      const configResult = await configStore.crear({
        id_instrumento: nuevo.id_instrumento,
        id_indicador: props.idIndicador,
        vigencia_desde: vigenciaDesde.value,
        vigencia_hasta: vigenciaHasta.value,
        titulo: nombreFormulario.value.trim() || undefined,
        instrucciones: instruccionesFormulario.value.trim() || undefined
      })
      if (configResult.ok && configResult.data?.id_configuracion) {
        await configStore.publicar(configResult.data.id_configuracion)
      } else if (!configResult.ok) {
        mostrarMensaje(`Instrumento guardado. No se generó el formulario: ${primerError(configResult)}`, 'error')
        return
      }
    }

    sessionStorage.setItem('instrumento_creado', `Instrumento "${nuevo.herramienta}" creado correctamente`)
    emit('cerrar')
  } catch (err: any) {
    console.error('Error al guardar instrumento completo:', err)
    mostrarMensaje(err?.message || 'Error al guardar instrumento completo', 'error')
  } finally {
    loadingAccion.value = false
  }
}

function cancelarPregunta() {
  mostrarFormPregunta.value = false
  tipoPregunta.value = ''
  enunciadoPregunta.value = ''
  opcionesPregunta.value = []
  opcionesTextoPregunta.value = ''
  escalaMinPregunta.value = 1
  escalaMaxPregunta.value = 5
  etiquetaMinPregunta.value = ''
  etiquetaMaxPregunta.value = ''
  variantesOpinion.value = []
  criteriosOpinion.value = []
}

function eliminarPregunta(grupo: any, id_temp: number) {
  grupo.preguntas = grupo.preguntas.filter((p: any) => p.id_temp !== id_temp)
}

function salir() {
  emit('cerrar')
}

return (_ctx: any,_cache: any) => {
  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LoadingOverlay, {
            visible: loading.value,
            message: "Cargando instrumento..."
          }, null, 8, ["visible"]),
          _createVNode(LoadingOverlay, {
            visible: loadingAccion.value,
            message: loadingMensaje.value
          }, null, 8, ["visible", "message"]),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("header", _hoisted_4, [
                  _createElementVNode("h1", null, _toDisplayString(modoEdicion.value ? 'Modificar instrumento' : 'Instrumentos'), 1),
                  _cache[30] || (_cache[30] = _createElementVNode("p", null, "Registro de instrumentos de evaluación", -1))
                ]),
                _createElementVNode("main", null, [
                  (modoEdicion.value && editandoInstrumento.value?.estado)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "estado-label" }, "Estado actual:", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['estado-badge', `estado-${editandoInstrumento.value.estado}`])
                        }, _toDisplayString(editandoInstrumento.value.estado), 3)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("section", _hoisted_6, [
                    _cache[36] || (_cache[36] = _createElementVNode("h2", null, "Seleccione un instrumento", -1)),
                    _createElementVNode("div", _hoisted_7, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nombreInstrumento).value = $event)),
                        class: "input-flex"
                      }, [
                        _cache[32] || (_cache[32] = _createElementVNode("option", {
                          disabled: "",
                          value: ""
                        }, "Seleccione...", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesInstrumentos.value, (inst) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: inst,
                            value: inst
                          }, _toDisplayString(inst), 9, _hoisted_8))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, nombreInstrumento.value]
                      ]),
                      _createElementVNode("button", {
                        class: "btn guardar",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (mostrarFormInstrumento.value = true))
                      }, "Agregar nuevo")
                    ]),
                    (mostrarFormInstrumento.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _cache[35] || (_cache[35] = _createElementVNode("h3", null, "Nuevo instrumento", -1)),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[33] || (_cache[33] = _createElementVNode("label", null, "Nombre", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((nombreInstrumento).value = $event))
                            }, null, 512), [
                              [_vModelText, nombreInstrumento.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _cache[34] || (_cache[34] = _createElementVNode("label", null, "Descripción", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((descripcionInstrumento).value = $event))
                            }, null, 512), [
                              [_vModelText, descripcionInstrumento.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                              class: "btn salir",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (mostrarFormInstrumento.value = false))
                            }, "Cancelar"),
                            _createElementVNode("button", {
                              class: "btn guardar",
                              onClick: nuevoInstrumentoLocal
                            }, "Agregar instrumento")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (instrumentoSeleccionado.value && requiereGruposYPreguntas())
                    ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                        _cache[41] || (_cache[41] = _createElementVNode("h2", null, "Datos del formulario", -1)),
                        _cache[42] || (_cache[42] = _createElementVNode("p", { class: "card-desc" }, "Al guardar se generará un formulario de Google Forms con las preguntas del instrumento.", -1)),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", null, "Nombre del formulario", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((nombreFormulario).value = $event)),
                            placeholder: "Ej: Encuesta de percepción — Reglamento estudiantil"
                          }, null, 512), [
                            [_vModelText, nombreFormulario.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", null, "Instrucciones (se muestran dentro del formulario)", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((instruccionesFormulario).value = $event)),
                            rows: "3",
                            placeholder: "Ej: Responda con sinceridad. Sus respuestas son confidenciales."
                          }, null, 512), [
                            [_vModelText, instruccionesFormulario.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _cache[39] || (_cache[39] = _createElementVNode("label", null, "Vigencia desde", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((vigenciaDesde).value = $event))
                            }, null, 512), [
                              [_vModelText, vigenciaDesde.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", null, "Vigencia hasta", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((vigenciaHasta).value = $event))
                            }, null, 512), [
                              [_vModelText, vigenciaHasta.value]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (instrumentoSeleccionado.value && requiereGruposYPreguntas())
                    ? (_openBlock(), _createElementBlock("section", _hoisted_19, [
                        _cache[65] || (_cache[65] = _createElementVNode("h2", null, "Grupos de interés", -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((grupoSeleccionado).value = $event)),
                            class: "input-flex"
                          }, [
                            _cache[43] || (_cache[43] = _createElementVNode("option", {
                              disabled: "",
                              value: ""
                            }, "Seleccione un grupo...", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grupoStore).grupos, (g) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: g.id_grupo_interes,
                                value: g
                              }, _toDisplayString(g.nombre), 9, _hoisted_21))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, grupoSeleccionado.value]
                          ]),
                          _createElementVNode("button", {
                            class: "btn guardar",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (mostrarGrupoForm.value = true))
                          }, "Agregar nuevo")
                        ]),
                        (grupoSeleccionado.value && instrumentoSeleccionado.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("button", {
                                class: "btn vincular",
                                onClick: vincularGrupoSeleccionado
                              }, " Vincular grupo seleccionado ")
                            ]))
                          : _createCommentVNode("", true),
                        (mostrarGrupoForm.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[47] || (_cache[47] = _createElementVNode("h3", null, "Nuevo grupo de interés", -1)),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[44] || (_cache[44] = _createElementVNode("label", null, "Estamento", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((nombreGrupo).value = $event))
                                }, null, 512), [
                                  [_vModelText, nombreGrupo.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _cache[45] || (_cache[45] = _createElementVNode("label", null, "Tipo de muestreo", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((tipoMuestreo).value = $event))
                                }, null, 512), [
                                  [_vModelText, tipoMuestreo.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[46] || (_cache[46] = _createElementVNode("label", null, "Criterios", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((criterio).value = $event))
                                }, null, 512), [
                                  [_vModelText, criterio.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("button", {
                                  class: "btn salir",
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (mostrarGrupoForm.value = false))
                                }, "Cancelar"),
                                _createElementVNode("button", {
                                  class: "btn guardar",
                                  onClick: agregarGrupoLocal
                                }, "Guardar grupo")
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (instrumentoSeleccionado.value?.grupos_interes?.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _cache[54] || (_cache[54] = _createElementVNode("h3", null, "Grupos vinculados", -1)),
                              _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instrumentoSeleccionado.value.grupos_interes, (g) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: g.id_temp || g.id_grupo_interes,
                                    class: _normalizeClass(['grupo-btn', grupoActivo.value === g ? 'active' : '']),
                                    onClick: ($event: any) => (grupoActivo.value = g)
                                  }, _toDisplayString(g.nombre), 11, _hoisted_30))
                                }), 128))
                              ]),
                              (!grupoActivo.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instrumentoSeleccionado.value.grupos_interes, (g) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: g.id_temp || g.id_grupo_interes,
                                          class: "hint-flecha-item"
                                        }, "↑"))
                                      }), 128))
                                    ]),
                                    _cache[48] || (_cache[48] = _createElementVNode("p", { class: "hint-seleccionar-texto" }, "Pulse sobre un grupo para ver y agregar sus preguntas", -1))
                                  ]))
                                : _createCommentVNode("", true),
                              (grupoActivo.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("h4", null, "Preguntas de " + _toDisplayString(grupoActivo.value.nombre), 1),
                                      (grupoActivo.value.preguntas?.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(grupoActivo.value.preguntas.length), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupoActivo.value.preguntas, (p, idx) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: p.id_temp || p.id_pregunta,
                                        class: "q"
                                      }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("span", _hoisted_37, _toDisplayString(Number(idx) + 1), 1),
                                          _createElementVNode("span", _hoisted_38, _toDisplayString(p.enunciado), 1),
                                          (p.tipo_respuesta)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(etiquetaTipo(p.tipo_respuesta)), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (Array.isArray(p.opciones) && p.opciones.length)
                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_40, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.opciones, (op, i) => {
                                                return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(op), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (p.tipo_respuesta === 'long_text')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _cache[49] || (_cache[49] = [
                                              _createElementVNode("span", { class: "muted" }, "Respuesta del usuario…", -1)
                                            ])))
                                          : _createCommentVNode("", true),
                                        (p.tipo_respuesta === 'rating')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              _cache[50] || (_cache[50] = _createElementVNode("span", { class: "muted" }, "Escala:", -1)),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.opciones, (n) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                  key: n,
                                                  class: "rating-opt"
                                                }, _toDisplayString(n), 1))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true),
                                        (p.tipo_respuesta === 'opinion')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                              _createElementVNode("table", _hoisted_44, [
                                                _createElementVNode("thead", null, [
                                                  _createElementVNode("tr", null, [
                                                    _cache[51] || (_cache[51] = _createElementVNode("th", null, "Variante", -1)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (c, i) => {
                                                      return (_openBlock(), _createElementBlock("th", { key: i }, _toDisplayString(c), 1))
                                                    }), 128))
                                                  ])
                                                ]),
                                                _createElementVNode("tbody", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.variantes, (v, i) => {
                                                    return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                                      _createElementVNode("td", null, _toDisplayString(v), 1),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.criterios, (c, j) => {
                                                        return (_openBlock(), _createElementBlock("td", { key: j }, _cache[52] || (_cache[52] = [
                                                          _createElementVNode("input", {
                                                            type: "checkbox",
                                                            disabled: ""
                                                          }, null, -1)
                                                        ])))
                                                      }), 128))
                                                    ]))
                                                  }), 128))
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_45, [
                                          ((instrumentoSeleccionado.value?.grupos_interes?.length ?? 0) > 1 && preguntaCopiar.value !== p)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn guardar btn-sm",
                                                type: "button",
                                                onClick: _withModifiers(($event: any) => (abrirCopia(p)), ["stop"])
                                              }, " Copiar a... ", 8, _hoisted_46))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn salir btn-sm",
                                            onClick: _withModifiers(($event: any) => (eliminarPregunta(grupoActivo.value, p.id_temp)), ["stop"])
                                          }, " Eliminar ", 8, _hoisted_47)
                                        ]),
                                        (preguntaCopiar.value === p)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                              _cache[53] || (_cache[53] = _createElementVNode("p", { class: "copia-titulo" }, "Selecciona los grupos destino:", -1)),
                                              _createElementVNode("div", _hoisted_49, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otrosGrupos.value, (g) => {
                                                  return (_openBlock(), _createElementBlock("label", {
                                                    key: g.id_temp ?? g.id_grupo_interes,
                                                    class: "grupo-check-item"
                                                  }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "checkbox",
                                                      value: g.id_temp ?? g.id_grupo_interes,
                                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((gruposCopiaDestino).value = $event))
                                                    }, null, 8, _hoisted_50), [
                                                      [_vModelCheckbox, gruposCopiaDestino.value]
                                                    ]),
                                                    _createTextVNode(" " + _toDisplayString(g.nombre), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn salir btn-sm",
                                                  onClick: _withModifiers(cancelarCopia, ["stop"])
                                                }, "Cancelar"),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "btn guardar btn-sm",
                                                  disabled: gruposCopiaDestino.value.length === 0 || copiando.value,
                                                  onClick: _withModifiers(copiarPreguntaAGrupos, ["stop"])
                                                }, _toDisplayString(copiando.value ? 'Copiando...' : 'Copiar'), 9, _hoisted_52)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("button", {
                                        class: "btn salir",
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (quitarGrupo(grupoActivo.value)))
                                      }, "Quitar grupo"),
                                      (_unref(authStore).tienePermiso('banco.ver'))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn guardar",
                                            onClick: _cache[17] || (_cache[17] = ($event: any) => (mostrarBancoModal.value = true))
                                          }, "Sugerir del banco"))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("button", {
                                        class: "btn guardar",
                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (mostrarFormPregunta.value = true))
                                      }, "Agregar pregunta")
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (mostrarFormPregunta.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _cache[64] || (_cache[64] = _createElementVNode("h4", null, "Nueva pregunta", -1)),
                              _createElementVNode("div", _hoisted_55, [
                                _cache[56] || (_cache[56] = _createElementVNode("label", null, "Tipo de pregunta", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((tipoPregunta).value = $event))
                                }, _cache[55] || (_cache[55] = [
                                  _createStaticVNode("<option disabled value=\"\" data-v-489a59d8>Seleccione...</option><option value=\"single_choice\" data-v-489a59d8>Opción única</option><option value=\"multiple_choice\" data-v-489a59d8>Casillas (opción múltiple)</option><option value=\"desplegable\" data-v-489a59d8>Lista desplegable</option><option value=\"escala_likert\" data-v-489a59d8>Escala Likert (1–5)</option><option value=\"escala_lineal\" data-v-489a59d8>Escala lineal (configurable)</option><option value=\"respuesta_corta\" data-v-489a59d8>Respuesta corta</option><option value=\"long_text\" data-v-489a59d8>Párrafo (respuesta larga)</option><option value=\"fecha\" data-v-489a59d8>Fecha</option><option value=\"hora\" data-v-489a59d8>Hora</option><option value=\"opinion\" data-v-489a59d8>Pregunta opinión</option>", 11)
                                ]), 512), [
                                  [_vModelSelect, tipoPregunta.value]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _cache[57] || (_cache[57] = _createElementVNode("label", null, "Enunciado", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((enunciadoPregunta).value = $event))
                                }, null, 512), [
                                  [_vModelText, enunciadoPregunta.value]
                                ])
                              ]),
                              (esTipoSeleccionPregunta.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _cache[58] || (_cache[58] = _createElementVNode("label", null, "Opciones (una por línea, mínimo 2)", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((opcionesTextoPregunta).value = $event)),
                                      rows: "4",
                                      placeholder: "Opción 1\nOpción 2\nOpción 3"
                                    }, null, 512), [
                                      [_vModelText, opcionesTextoPregunta.value]
                                    ])
                                  ]))
                                : (tipoPregunta.value === 'escala_lineal')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      _createElementVNode("div", _hoisted_59, [
                                        _cache[60] || (_cache[60] = _createElementVNode("label", null, "Desde", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((escalaMinPregunta).value = $event))
                                        }, _cache[59] || (_cache[59] = [
                                          _createElementVNode("option", { value: 0 }, "0", -1),
                                          _createElementVNode("option", { value: 1 }, "1", -1)
                                        ]), 512), [
                                          [
                                            _vModelSelect,
                                            escalaMinPregunta.value,
                                            void 0,
                                            { number: true }
                                          ]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[61] || (_cache[61] = _createElementVNode("label", null, "Hasta", -1)),
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((escalaMaxPregunta).value = $event))
                                        }, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(9, (n) => {
                                            return _createElementVNode("option", {
                                              key: n,
                                              value: n + 1
                                            }, _toDisplayString(n + 1), 9, _hoisted_61)
                                          }), 64))
                                        ], 512), [
                                          [
                                            _vModelSelect,
                                            escalaMaxPregunta.value,
                                            void 0,
                                            { number: true }
                                          ]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_62, [
                                        _cache[62] || (_cache[62] = _createElementVNode("label", null, "Etiqueta mínima (opcional)", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((etiquetaMinPregunta).value = $event)),
                                          placeholder: "Ej: Malo"
                                        }, null, 512), [
                                          [_vModelText, etiquetaMinPregunta.value]
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_63, [
                                        _cache[63] || (_cache[63] = _createElementVNode("label", null, "Etiqueta máxima (opcional)", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((etiquetaMaxPregunta).value = $event)),
                                          placeholder: "Ej: Excelente"
                                        }, null, 512), [
                                          [_vModelText, etiquetaMaxPregunta.value]
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("button", {
                                  class: "btn salir",
                                  onClick: cancelarPregunta
                                }, "Cancelar"),
                                _createElementVNode("button", {
                                  class: "btn guardar",
                                  disabled: !puedeGuardarPreguntaLocal.value,
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (agregarPreguntaLocal(grupoActivo.value)))
                                }, " Guardar pregunta ", 8, _hoisted_65)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("button", {
                      class: "btn salir",
                      onClick: salir,
                      disabled: loadingAccion.value
                    }, "Salir", 8, _hoisted_67),
                    (modoEdicion.value ? _unref(authStore).tienePermiso('instrumentos.editar') : _unref(authStore).tienePermiso('instrumentos.crear'))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn guardar",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (guardarInstrumento())),
                          disabled: loadingAccion.value
                        }, _toDisplayString(loadingAccion.value ? 'Guardando…' : (modoEdicion.value ? 'Guardar cambios' : 'Guardar instrumento')), 9, _hoisted_68))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(MensajeFlotante, {
            visible: mensajeVisible.value,
            mensaje: mensajeTexto.value,
            tipo: mensajeTipo.value,
            onCerrar: _cache[28] || (_cache[28] = ($event: any) => (mensajeVisible.value = false))
          }, null, 8, ["visible", "mensaje", "tipo"])
        ]),
        _createVNode(BancoPreguntasSugerenciasModal, {
          modelValue: mostrarBancoModal.value,
          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((mostrarBancoModal).value = $event)),
          idTipoComponente: props.idTipoComponente,
          nombreComponente: tipoComponenteActual.value?.nombre ?? tipoComponenteActual.value?.tipo,
          onAgregar: agregarDesdeBanco
        }, null, 8, ["modelValue", "idTipoComponente", "nombreComponente"])
      ]))
    : _createCommentVNode("", true)
}
}

})